export class ConsignerModel {
    id:                 number=null;
    consignerName:       string=null;
    description:         string=null;
    gst:      number=null;
}